/* Mixin for validations */

export default {
  data() {
    return {
      validationMessages: {},
      validated: false,
    }
  },
  methods: {
    /**
     * Get validation error messages for element
     *
     * @param name
     * @return {[]}
     */
    getValidationsErrors(name) {
      const errors = []

      if (!this.validated || !this.validationMessages[name] || !this.$v[name]) {
        return errors
      }

      Object.keys(this.$v[name].$params).forEach(validator => {
        if (this.validationMessages[name][validator]) {
          !this.$v[name][validator] &&
            errors.push(this.validationMessages[name][validator])
        }
      })

      return errors
    },

    /**
     * Return valid state of component
     *
     * @param {String} ref
     * @return {boolean}
     */
    getValidState(ref = null) {
      if (ref) {
        if (
          this.$refs[ref] &&
          typeof this.$refs[ref].getValidState === "function"
        ) {
          return this.$refs[ref].getValidState()
        }

        return true
      }

      return this.$v && this.validated ? !this.$v.$invalid : true
    },

    /**
     * Get validation state of element
     *
     * @param {String} name
     * @returns {boolean}
     */
    getValidationState(name) {
      return this.validated ? !this.$v[name].$invalid : null
    },

    /**
     * Validate component or element by name
     *
     * @returns {boolean}
     */
    isValid(name = null) {
      if (!this.$v) {
        return true
      }

      if (name) {
        if (this.$v[name]) {
          return this.$v[name].$touch() && !this.$v[name].$invalid
        }

        return true
      }

      this.validated = true
      this.$v.$touch()

      return !this.$v.$invalid
    },

    /**
     * Validate component and sub-components by refs
     *
     * @param {Array} excludedRefs
     * @returns {boolean}
     */
    isValidAll(excludedRefs = []) {
      let child = null
      let valid = true

      // go by refs through sub-components like tabs and validate them also if exists
      Object.keys(this.$refs).forEach(key => {
        if (excludedRefs.indexOf(key) < 0) {
          child = this.$refs[key]

          // refs added in v-for loop are array
          if (Array.isArray(child)) {
            child.forEach(loopChild => {
              if (
                typeof loopChild.isValid === "function" &&
                !loopChild.isValid()
              ) {
                valid = false
              }
            })
          }

          if (typeof child.isValid === "function" && !child.isValid()) {
            valid = false
          }
        }
      })

      if (!this.isValid()) {
        valid = false
      }

      return valid
    },

    validationReset() {
      this.validated = false
    },
  },
}
